import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {Keyboard} from '@awesome-cordova-plugins/keyboard/ngx';
import {LoginPasswordPage} from './login-password';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
  ],
  declarations: [LoginPasswordPage],
  providers: [
    Keyboard,
  ],
})
export class LoginPasswordPageModule {}
